/* eslint-disable @typescript-eslint/no-explicit-any */
/*eslint-disable @typescript-eslint/no-unnecessary-condition */

export class ObjectService {
  static removeUndefinedProperties<T>(object: T) {
    return ObjectService.removePropertiesInternal(
      object,
      ValueMatch.UNDEFINED,
    ) as T;
  }

  static removeUndefinedAndNullProperties<T>(object: T) {
    return ObjectService.removePropertiesInternal(object, ValueMatch.ALL) as T;
  }

  private static removePropertiesInternal<T>(
    object: T,
    valueMatch: ValueMatch,
  ): NestedObject<T> {
    if (
      typeof object !== "object" ||
      object === null ||
      object instanceof Date
    ) {
      return object;
    }

    if (Array.isArray(object)) {
      return object.map((property) =>
        ObjectService.removePropertiesInternal(property, valueMatch),
      ) as NestedObject<T>;
    }

    const result = {} as NestedObject<T>;

    for (const key in object) {
      const value = ObjectService.removePropertiesInternal(
        object[key],
        valueMatch,
      );

      ObjectService.tryRemoveProperty<T>(valueMatch, value, result, key);
    }

    return result;
  }

  static tryRemoveProperty<T>(
    valueMatch: ValueMatch,
    value: NestedObject<(T & object)[Extract<keyof T, string>]>,
    result: NestedObject<T>,
    key: Extract<keyof T, string>,
  ) {
    if (valueMatch === ValueMatch.ALL) {
      if (value !== undefined && value !== null) {
        result[key] = value;
      }
    }

    if (valueMatch === ValueMatch.UNDEFINED) {
      if (value !== undefined) {
        result[key] = value;
      }
    }

    if (valueMatch === ValueMatch.NULL) {
      if (value !== null) {
        result[key] = value;
      }
    }
  }
}

type NestedObject<T> = {
  [P in keyof T]?: NestedObject<T[P]>;
};

enum ValueMatch {
  UNDEFINED = "Undefined",
  NULL = "Null",
  ALL = "Both",
}
